module.exports = __webpack_public_path__ + "assets/58cac9c281fd9d2418c1820bb840b02b.mp4";